
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { MaterialModule } from './material/material.module';

// used to create fake backend
import { fakeBackendProvider } from './_helpers';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SignupService } from './shared/signup.service';
import { ReactiveFormsModule } from "@angular/forms";
import { FlexLayoutModule } from '@angular/flex-layout';
//import { ConfirmEqualValidatorDirective } from './shared/confirm-equal-validator.directive';
import { CookieService } from 'ngx-cookie-service';
import { AngularFontAwesomeModule} from 'angular-font-awesome';
import { FormsModule } from '@angular/forms';
import { MynavComponent } from './mynav/mynav.component';
import { FooterComponent } from './footer/footer.component';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  declarations:[ 
    AppComponent,
    MynavComponent,
    FooterComponent, 
  ],
  
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    AngularFontAwesomeModule,
    FormsModule,  
    HttpClientModule,
  ],
  providers: [ 
   
    {
      provide: MatDialogRef,
      useValue: []
    },
    {
      provide: MAT_DIALOG_DATA,
      useValue: []
    },

    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    // provider used to create fake backend
    fakeBackendProvider
  ], 


  bootstrap: [ AppComponent ]
})
export class AppModule { 
  
}
